import React from 'react';

const ReportsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="container-width section-padding py-20">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Transparency Reports</h1>
          <p className="text-xl text-gray-600">Coming soon - Published reports and documents</p>
        </div>
      </div>
    </div>
  );
};

export default ReportsPage;
